module.exports = __webpack_public_path__ + "img/ypdc2.fa05d8a4.jpg";